import AvatarEditor from 'react-avatar-editor';
import AWSHelper from 'helpers/AWSHelper';
import AlertHelper from 'helpers/AlertHelper';

import { useState, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Avatar from 'components/ui/Avatar';
import NotificationHelper from 'helpers/NotificationHelper';

const UserAvatarForm = ({ user, edit_mode_on, type }) => {
  const [edit_mode, setEditMode] = useState(edit_mode_on);

  if (!user) {
    return null;
  }

  const MainComponent = edit_mode ? AvatarEditorCard : UserAvatar;

  return (
    <div className="card">
      <div className="card-body">
        <h6 className="mb-3 col-md-8 text-muted text-uppercase">Avatar</h6>
        <hr />
        <div className="text-center">
          <MainComponent
            user={user}
            type={type}
            show_cancel_btn={edit_mode_on}
            toggleEditMode={() => (!edit_mode_on ? setEditMode(!edit_mode) : null)}
          />
        </div>
      </div>
    </div>
  );
};

const AvatarEditorCard = ({ user, show_cancel_btn, toggleEditMode, type }) => {
  const { t } = useTranslation();

  const editorRef = useRef(null);
  const [scale, setScale] = useState(1);

  const [image, setImage] = useState(user.profile_image);

  const [saving, setSaving] = useState(false);
  const handleScale = e => setScale(parseFloat(e.target.value));
  const handleNewImage = e => setImage(e.target.files[0]);

  const object_params = {
    Bucket: `img.youfy.com.br/${type || 'user'}`,
    Key: `${user.id}.jpeg`,
  };

  const removeImage = async () => {
    const result = await AlertHelper.confirmDanger({
      text: t('profile.dialogs.remove_avatar'),
    });

    if (result.value) {
      try {
        setSaving(true);

        await AWSHelper.removeFromS3(object_params);
        NotificationHelper.snack(t('profile.messages.success_avatar_removed'));
        setImage(false);
        setTimeout(toggleEditMode, 100);
      } finally {
        setSaving(false);
      }
    }
  };

  const saveImage = async () => {
    const editor = editorRef.current;

    if (editor) {
      try {
        setSaving(true);

        const res = await fetch(editor.getImageScaledToCanvas().toDataURL());
        const blob = await res.blob();

        const params = {
          Body: blob,
          ...object_params,
        };

        await AWSHelper.upload2S3(params);
        NotificationHelper.snack(t('profile.messages.success_avatar_changed'));
        setTimeout(toggleEditMode, 100);
      } finally {
        setSaving(false);
      }
    }
  };

  const renderCancelButton = () => {
    if (show_cancel_btn) {
      return null;
    }

    return (
      <div>
        <button type="button" disabled={saving} onClick={toggleEditMode} className="btn mt-3">
          {t('actions.cancel')}
        </button>
      </div>
    );
  };

  return (
    <>
      <AvatarEditor
        ref={editor => (editorRef.current = editor)}
        image={image}
        width={150}
        height={150}
        border={10}
        color={[255, 255, 255, 0.6]} // RGBA
        scale={scale}
        rotate={0}
        crossOrigin="anonymous"
      />

      <div>
        <input type="range" step="0.01" min="1" max="2" name="scale" defaultValue="1" onChange={handleScale} />
      </div>

      <div className="form-group mt-3">
        <input className="form-control" type="file" onChange={handleNewImage} />
      </div>

      <hr />

      <div>
        <button type="button" disabled={saving} onClick={saveImage} className="btn btn-primary">
          {t('actions.save')}
        </button>

        <button type="button" disabled={saving} onClick={removeImage} className="btn btn-outline-danger ms-3">
          {t('actions.remove')}
        </button>

        {renderCancelButton()}
      </div>
    </>
  );
};

const UserAvatar = ({ user, toggleEditMode }) => {
  const { t } = useTranslation();

  const image = user.profile_image;

  return (
    <>
      <div className="mt-4">
        <Avatar name={user.name} email={user.email} src={image} size={150} />
      </div>
      <div className="mt-4 mb-3">
        <button className="btn btn-outline-primary" onClick={toggleEditMode}>
          {t('actions.change')}
        </button>
      </div>
    </>
  );
};

export default withRouter(UserAvatarForm);
